/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_Team_AInputs */

const en_mk_faq_team_a = /** @type {(inputs: Mk_Faq_Team_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep assigns tasks by dependencies and file scope. Independent tasks use separate working folders; dependent or conflicting work runs in sequence. Results are then combined and checked before completion. You can send guidance, stop the team, and approve checkpoints to continue.`)
};

const id_mk_faq_team_a = /** @type {(inputs: Mk_Faq_Team_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep membagi tugas berdasarkan dependensi dan lingkup berkas. Tugas mandiri memakai folder kerja terpisah; tugas yang saling bergantung atau berbenturan dikerjakan berurutan. Hasil kemudian digabung dan diperiksa sebelum selesai. Kamu bisa mengirim arahan, menghentikan tim, dan menyetujui checkpoint untuk lanjut.`)
};

/**
* | output |
* | --- |
* | "Bystep assigns tasks by dependencies and file scope. Independent tasks use separate working folders; dependent or conflicting work runs in sequence. Results ..." |
*
* @param {Mk_Faq_Team_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_team_a = /** @type {((inputs?: Mk_Faq_Team_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_Team_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_team_a(inputs)
	return en_mk_faq_team_a(inputs)
});